import { useEffect, useState } from 'react';

import { useFeatureServices } from './use-feature-services';

export function useDisclaimerReference(
  disclaimerText: string | undefined,
  scope?: string,
): string | undefined {
  const featureServices = useFeatureServices();
  const [disclaimerReference, setDisclaimerReference] = useState<
    string | undefined
  >();

  useEffect(() => {
    if (!disclaimerText) {
      return;
    }

    const disclaimerManager =
      featureServices['disclaimer-manager'].getScopedDisclaimerManager(scope);

    const registeredDisclaimerReference =
      disclaimerManager.registerReferenceDisclaimer(
        'module-reference',
        disclaimerText,
      );

    setDisclaimerReference(registeredDisclaimerReference);

    return () => {
      disclaimerManager.unregisterReferenceDisclaimer(
        'module-reference',
        disclaimerText,
      );
    };
  }, [disclaimerText, featureServices, scope]);

  return disclaimerReference;
}
